import { useSideNavIsVisible } from "../hooks/use-side-nav-is-visible";

export const withSideNav = (Cmp, isVisible) => (props) => {
  useSideNavIsVisible(isVisible);
  return <Cmp {...props} />;
};
